import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  triggerSurveyForAllSessionOfUser: {
    method: 'POST',
    url: `${configs.baseUrl}/api/presentation-session/trigger-survey`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const triggerSurveyForAllSessionOfUser = async () => {
  return resource.triggerSurveyForAllSessionOfUser()
}

export default {
  initResource,
  triggerSurveyForAllSessionOfUser,
}
